
// store/modules/rates.js
import axios from 'axios';

const state = {
  prices: null,
  virtual: null,
  centralLondon: null,
  insideM25: null,
  outsideM25: null,
  loadingPrices: false,
};

const getters = {
  getPrices: state => state.prices,
  getVirtualPrice: state => state.virtual,
  getCentralLondonPrice: state => state.centralLondon,
  getInsideM25Price: state => state.insideM25,
  getOutsideM25Price: state => state.outsideM25,
  getLoadingPrices: state => state.loadingPrices,
};

const mutations = {
  setPrices(state, prices) {
    state.prices = prices;
    state.virtual = prices.Virtual;

    // fallback
    state.centralLondon = prices.CentralLondon || prices.InsideM25 || prices.OutsideM25;
    state.insideM25 = prices.InsideM25 || prices.OutsideM25;
    state.outsideM25 = prices.OutsideM25;
  },
  setLoadingPrices(state, loading) {
    state.loadingPrices = loading;
  }
};


const actions = {
  async fetchPrices({ commit }) {
    try {
      commit('setLoadingPrices', true);
      const response = await axios.get('v1/rates');
      commit('setPrices', response.data);
      commit('setLoadingPrices', false);
    } catch (error) {
      console.error('Error fetching prices:', error);
    }
  },
};

export const rates = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

